__turbopack_context__.v({
  "armed": "illustrations-module__p9_PPG__armed",
  "caption": "illustrations-module__p9_PPG__caption",
  "captionNote": "illustrations-module__p9_PPG__captionNote",
  "captionTitle": "illustrations-module__p9_PPG__captionTitle",
  "closerSmall": "illustrations-module__p9_PPG__closerSmall",
  "closerWide": "illustrations-module__p9_PPG__closerWide",
  "duoCompact": "illustrations-module__p9_PPG__duoCompact",
  "duoWide": "illustrations-module__p9_PPG__duoWide",
  "full": "illustrations-module__p9_PPG__full",
  "gallery": "illustrations-module__p9_PPG__gallery",
  "header": "illustrations-module__p9_PPG__header",
  "image": "illustrations-module__p9_PPG__image",
  "item": "illustrations-module__p9_PPG__item",
  "leadWide": "illustrations-module__p9_PPG__leadWide",
  "page": "illustrations-module__p9_PPG__page",
  "pairLarge": "illustrations-module__p9_PPG__pairLarge",
  "pairSmall": "illustrations-module__p9_PPG__pairSmall",
  "panelEnd": "illustrations-module__p9_PPG__panelEnd",
  "panelMid": "illustrations-module__p9_PPG__panelMid",
  "panelStart": "illustrations-module__p9_PPG__panelStart",
  "plate": "illustrations-module__p9_PPG__plate",
  "plateSquareTop": "illustrations-module__p9_PPG__plateSquareTop",
  "sheetEnd": "illustrations-module__p9_PPG__sheetEnd",
  "sheetStart": "illustrations-module__p9_PPG__sheetStart",
  "shown": "illustrations-module__p9_PPG__shown",
  "trailTall": "illustrations-module__p9_PPG__trailTall",
  "trioEnd": "illustrations-module__p9_PPG__trioEnd",
  "trioMid": "illustrations-module__p9_PPG__trioMid",
  "trioStart": "illustrations-module__p9_PPG__trioStart",
});
